"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitize = sanitize;
exports.sanitizeProperties = sanitizeProperties;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
function sanitize(content) {
    const user = process.env.USERNAME === undefined ? process.env.USER : process.env.USERNAME;
    if (user === undefined) {
        // Couldn't determine user, therefore can't truly sanitize the content.
        return content;
    }
    const replacer = new RegExp(user, 'g');
    const sanitizedContent = content.replace(replacer, 'anonymous');
    return sanitizedContent;
}
function sanitizeProperties(properties) {
    if (properties === undefined) {
        return properties;
    }
    const sanitizedProperties = {};
    for (const property of Object.keys(properties !== null && properties !== void 0 ? properties : {})) {
        sanitizedProperties[property] = sanitize(properties[property]);
    }
    return sanitizedProperties;
}
//# sourceMappingURL=ContentSantizer.js.map